// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { StorefrontAccess } from "@insite/client-framework/Services/SettingsService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { getProductByPath } from "@store/Modules/client-framework/src/Services/ProductServiceV2";
import { addToChainAfter, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter.expand = props.apiParameter.expand || [];
    props.apiParameter.expand.push("properties");
});

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        props.apiResult = await getProductByPath(props.apiParameter); // Store Custom Code - import path
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }

        const { storefrontAccess } = getSettingsCollection(props.getState()).productSettings;
        if (storefrontAccess === StorefrontAccess.SignInRequiredToBrowse && error.status === 403) {
            // auth timed out with SignInRequiredToBrowsee - throw this up as a 401 so DisplayError reloads the site
            error.status = 401;
            error.errorJson = { message: "error" };
        }

        throw error;
    }
});
